<template>
    <header v-if="title" class="accordion__header h1">
        {{ title }}
    </header>

    <div class="accordion__body">
        <accordion-item
            v-for="(item, index) in items"
            :item="item"
            :key="`item-${index}`"></accordion-item>
    </div>
</template>

<script setup lang="ts">
import { IAccordionItem } from './interface/accordion.model';
import accordionItem from './components/accordion-item.component.vue';

defineProps<{
    title: string;
    items: IAccordionItem[];
}>();
</script>
